(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/joker/joker.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/joker/joker.js');

'use strict';

const {
  Currency
} = svs.utils.format;
svs.numbergames.game.views.Joker = Marionette.View.extend({
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "joker-wrapper joker-wrapper-".concat(brandingSuffix);
  },
  regions: {
    jokerPriceRegion: '#jokerPriceRegion',
    jokerRowRegion: '#jokerRowRegion',
    jokerInputRegion: '#jokerInputRegion',
    topWinRegion: '#topWinRegion',
    withoutJokerTextRegion: '#withoutJokerTextRegion'
  },
  ui: {
    rowWrapper: '.js-joker-row-wrapper',
    withoutJokerText: '.js-without-joker-info-text'
  },
  childViewTriggers: {
    ballRowClicked: 'showInput',
    jokerInputDone: 'showRow',
    addRowFocus: 'focusRow'
  },
  modelEvents: {
    'change:hasJoker': 'changedHasJoker',
    'change:isSubscription': 'onCheckJoker'
  },
  template(data) {
    return svs.numbergames.game.templates.joker(data);
  },
  templateContext() {
    var _svs$numbergames$game;
    return {
      withoutJokerText: (_svs$numbergames$game = svs.numbergames.game.view_options[this.model.get('productId')]) === null || _svs$numbergames$game === void 0 ? void 0 : _svs$numbergames$game.withoutJokerText
    };
  },
  onRender() {
    this.showChildView('jokerPriceRegion', new svs.numbergames.game.views.JokerPrice({
      model: this.model
    }));
    this.showChildView('topWinRegion', new Marionette.View({
      className: 'numbergames-footer-section-info-text',
      model: this.model,
      modelEvents: {
        'change:jokerPrice': 'render'
      },
      template: () => "<p>Toppvinst: ".concat(Currency(svs.numbergames.rules.joker.getTopWin(this.model.get('jokerPrice'))), " kr</p>")
    }));
    if (svs.numbergames.rules.joker.isValidRow(this.model.getJokerRowAsArray())) {
      this.onShowRow();
    } else {
      this.onShowInput();
    }
  },
  onAttach() {
    this.toggleRowAnimations = svs.numbergames.game.animations.joker.getToggleRowWrapperAnimations({
      rowEl: this.getUI('rowWrapper'),
      textEl: this.getUI('withoutJokerText')
    });
    if (this.model.get('hasJoker')) {
      this.toggleRowAnimations.showRow().progress(1);
    }
    this.onCheckJoker();
  },
  changedHasJoker(model, hasJoker) {
    if (hasJoker) {
      this.toggleRowAnimations.showRow();
    } else {
      this.toggleRowAnimations.showText();
    }
  },
  onCheckJoker() {
    if (this.model.get('hasJoker') && !this.model.get('isSubscription') && !svs.numbergames.game.draw.isJokerOpen) {
      this.model.set({
        jokerPrice: 0
      });
      this.getChildView('jokerPriceRegion').triggerMethod('updateDOMSelection');
    }
  },
  onFocusRow() {
    this.$el.find('.js-joker-ball-row').focus();
  },
  onShowRow() {
    const currentView = this.getChildView('jokerInputRegion');
    if (currentView) {
      currentView.destroy();
    }
    this.showChildView('jokerRowRegion', new svs.numbergames.game.views.JokerHuxfluxRow({
      model: this.model
    }));
    this.onFocusRow();
  },
  onShowInput() {
    const currentView = this.getChildView('jokerRowRegion');
    if (currentView) {
      currentView.destroy();
    }
    this.showChildView('jokerInputRegion', new svs.numbergames.game.views.JokerInput({
      model: this.model
    }));
  }
});

 })(window);